import { ConsentType } from 'graphql/person/generates';

export const PersonConsentType = {
  Gdpr: ConsentType.Eewe,
  Finleap: ConsentType.FinleapConnect,
};
